module.exports = __webpack_public_path__ + "static/media/Forgot-Password.de94f367.svg";